const formatPdpAttributesFromDatabridge = (suggestedSearchDatabridgeObject) => {
  if (Object.keys(suggestedSearchDatabridgeObject || {}).length === 0) return {};

  const breadcrumbsArrayFromDatabridge = suggestedSearchDatabridgeObject.breadcrumbs || [];
  const aiAttributesArrayFromDatabridge = suggestedSearchDatabridgeObject.AI_Attributes || [];

  const colorFamilyFromDatabridge = suggestedSearchDatabridgeObject.colorFamily || '';
  const genderFromDatabridge = suggestedSearchDatabridgeObject.gender || '';
  const productNameFromDatabridge = suggestedSearchDatabridgeObject.productName || '';
  const l1FromDatabridge = breadcrumbsArrayFromDatabridge.length >= 1 ? breadcrumbsArrayFromDatabridge[1] : '';
  const l2FromDatabridge = breadcrumbsArrayFromDatabridge.length >= 2 ? breadcrumbsArrayFromDatabridge[2] : '';
  const l3FromDatabridge = breadcrumbsArrayFromDatabridge.length >= 3 ? breadcrumbsArrayFromDatabridge[3] : '';

  let occasionArrayFromDatabridge = [];
  let dressingStyleArrayFromDatabridge = [];
  let productTypeArrayFromDatabridge = [];

  aiAttributesArrayFromDatabridge.forEach((attr) => {
    if (attr.name === 'AI_Occasion') {
      occasionArrayFromDatabridge = attr.value;
    } else if (attr.name === 'AI_Dressing_Style') {
      dressingStyleArrayFromDatabridge = attr.value;
    } else if (attr.name === 'AI_Product_Type') {
      productTypeArrayFromDatabridge = attr.value;
    }
  });

  /*
    As far as occasion, dressingStyle, and productType go, these attributes can be multivalued!
    Taking the first one from the values array for each of them until we decide differently.
  */

  return {
    l1: l1FromDatabridge,
    l2: l2FromDatabridge,
    l3: l3FromDatabridge,
    gender: genderFromDatabridge,
    colorFamily: colorFamilyFromDatabridge,
    productName: productNameFromDatabridge,
    occasion: occasionArrayFromDatabridge.length ? occasionArrayFromDatabridge[0].value : '',
    dressingStyle: dressingStyleArrayFromDatabridge.length ? dressingStyleArrayFromDatabridge[0].value : '',
    productType: productTypeArrayFromDatabridge.length ? productTypeArrayFromDatabridge[0].value : '',
  };
};

export default formatPdpAttributesFromDatabridge;
